import {
  CloudAccountApiChangeDiscoverInventoryIntervalRequest,
  CloudAccountApiGetCloudAccountsRequest,
  PageCloudAccountGetResponse,
} from '@ariksa/cloud-account/api';
import {
  AvailableSLAResponse,
  GetSlasResponse,
  SlaApiAddAvailableSlaOptionsRequest,
  SlaApiDeleteAvailableSlaOptionsRequest,
  SlaApiUpdateSlaRequest,
  UpdateSlaResponse,
} from '@ariksa/notification/api';
import { QueryContext } from 'services/utils/QueryContext';
import { takeLatestAction } from 'services/utils/takeLatestAction';

import { CloudAccountService, NotificationService } from 'api/services';
import { actions } from 'containers/Settings/slice';

export function* settingsSaga() {
  // yield takeLatest(actions.updatePassword.type, doUpdatePassword);
  yield takeLatestAction(
    actions.updateAccountDiscoveryInterval,
    doUpdateAccountDiscoveryInterval,
  );
  yield takeLatestAction(actions.getCloudAccounts, doGetCloudAccounts);
  yield takeLatestAction(actions.updateSLAs, doUpdateSLAs);
  yield takeLatestAction(actions.getSLAs, doGetSLAs);
  yield takeLatestAction(
    actions.getAvailableSLAOptions,
    doGetAvailableSLAOptions,
  );
  yield takeLatestAction(
    actions.updateAvailableSlaOption,
    doUpdateAvailableSlaOption,
  );
  yield takeLatestAction(
    actions.deleteAvailableSlaOption,
    doDeleteAvailableSlaOption,
  );
}

export function* doGetAvailableSLAOptions(
  ctx: QueryContext<AvailableSLAResponse[]>,
) {
  yield ctx.fetch(() => NotificationService.SLA.getAvailableSlaOptions(), {});
}

export function* doUpdateAvailableSlaOption(
  ctx: QueryContext<any, SlaApiAddAvailableSlaOptionsRequest>,
) {
  yield ctx.fetch(
    () => NotificationService.SLA.addAvailableSlaOptions(ctx.params),
    {
      successMsg: 'Updated SLAs successfully',
    },
  );
}

export function* doDeleteAvailableSlaOption(
  ctx: QueryContext<any, SlaApiDeleteAvailableSlaOptionsRequest>,
) {
  yield ctx.fetch(
    () => NotificationService.SLA.deleteAvailableSlaOptions(ctx.params),
    {
      successMsg: 'SLA option deleted successfully',
    },
  );
}

export function* doGetSLAs(ctx: QueryContext<GetSlasResponse[]>) {
  yield ctx.fetch(() => NotificationService.SLA.getSlas(), {});
}

export function* doUpdateSLAs(
  ctx: QueryContext<UpdateSlaResponse, SlaApiUpdateSlaRequest>,
) {
  yield ctx.fetch(() => NotificationService.SLA.updateSla(ctx.params), {
    successMsg: 'Updated SLAs successfully',
  });
}

export function* doGetCloudAccounts(
  ctx: QueryContext<
    PageCloudAccountGetResponse,
    CloudAccountApiGetCloudAccountsRequest
  >,
) {
  yield ctx.fetch(() =>
    CloudAccountService.CloudAccount.getCloudAccounts(ctx.params),
  );
}

export function* doUpdateAccountDiscoveryInterval(
  ctx: QueryContext<any, CloudAccountApiChangeDiscoverInventoryIntervalRequest>,
) {
  yield ctx.fetch(() =>
    CloudAccountService.CloudAccount.changeDiscoverInventoryInterval(
      ctx.params,
    ),
  );
}
